<template>
  <a-dropdown v-model="visible" :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-badge :count="count">
        <a-avatar shape="square" icon="notification" size="large" :class="$style.avatar"/>
      </a-badge>
    </div>
    <div slot="overlay" class="ant-dropdown-menu" :class="$style.activity">
      {{ items.length }}
      <div v-if="items.data !== undefined && items.data.length > 0">
        <a-menu :selectable="false" :class="$style['menu-content']">
          <a-menu-item class="ant-dropdown-menu-item" v-for="item in items.data" :key="item.ntn_id" :class="[$style.item, item.is_seen_count === 1 ? $style.selected : '']">
            <ion-icon :name="type" :class="[$style.icon, index > 0 ? $style.edit : '']" :key="'icon'+index" v-for="(type, index) in item.settings.icon"></ion-icon>
            <div :class="$style.inner">
              <div :class="$style.title">
                <div :class="$style['right-side']">
                  <span>{{ $options.filters.fromNowDate(item.created_at) }}</span>
                  <div :class="$style.actions">
                    <a-tooltip title="Označit jako přečtené" v-if="item.is_seen_count === 1">
                      <a href="javascript:;" @click="setRead([item.ntn_id])">
                        <ion-icon name="radio-button-on-outline"></ion-icon>
                      </a>
                    </a-tooltip>
                    <a-tooltip title="Označit jako nepřečtené" v-else>
                      <a href="javascript:;" @click="setUnRead(item.ntn_id)">
                        <ion-icon name="radio-button-off-outline"></ion-icon>
                      </a>
                    </a-tooltip>
                  </div>
                </div>
                <div :class="$style.descr">
                  Uživatel
                  <a href="javascript:;" @click="goToNotification(null, item)"><b>{{ item.user === null || item.user.uer_first_name === null ? '#'+item.uer_id : item.user.uer_first_name + ' ' + item.user.uer_last_name }}</b></a>
                  {{ item.settings.message }}
                  <a href="javascript:;" @click="goToNotification(getLinkTo(item), item)" v-if="item.svy_id !== null || item.rvw_id !== null || item.odr_id !== null || item.cmt_id !== null">
                    <b>#{{ item.svy_id || item.rvw_id || item.odr_id || item.cmt_id }}</b>
                  </a>
                </div>
              </div>
            </div>
          </a-menu-item>
          <a-menu-item :class="[$style.item, $style.next]" v-if="itemsNextCount">
            <a-button size="small" type="primary" class="width-200 d-block m-auto" @click="page += 1">Načíst další...</a-button>
          </a-menu-item>
        </a-menu>
        <div class="position-relative text-right">
          <ul :class="$style.options">
            <li :class="$style.option">
              <a href="javascript:;" @click="setRead([])">Označit vše jako přečtené</a>
            </li>
          </ul>
        </div>
      </div>
      <a-empty class="pt-4 pb-4" v-else>
        <a-spin v-if="loading" />
      </a-empty>
    </div>
  </a-dropdown>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      loaded: false,
      index: 0,
      page: 1,
    }
  },
  computed: {
    itemsNextCount: function () {
      return (this.items.count - this.items.data.length) > 0
    },
    items: function() {
      return this.$store.getters['notification/filteredItems'](this.page)
    },
    count: function() {
      return this.$store.getters['notification/getCount']
    },
  },
  methods: {
    goToNotification(path, item) {
      this.setRead([item.ntn_id], item)
        .then(() => {
          if (path === null) {
            if (item.user.uer_type === 'AMR') {
              this.$router.push({ name: 'user.admin.detail', params: { id: item.uer_id } }).catch(() => {})
            } else if (item.user.uer_type === 'RID') {
              this.$router.push({ name: 'user.registered.detail', params: { id: item.uer_id } }).catch(() => {})
            }
          } else {
            this.$router.push({ path: path }).catch(() => {})
          }
        })
    },
    getLinkTo(item) {
      if (item.svy_id !== null) {
        return '/survey/trend/' + item.svy_id
      }
      if (item.rvw_id !== null) {
        return '/ecommerce/product/detail/' + item.review.put_id + '/reviews/' + item.rvw_id
      }
      if (item.odr_id !== null) {
        return '/ecommerce/order/detail/' + item.odr_id
      }
      if (item.cmt_id !== null) {
        if (item.comment.put_id !== null) {
          return '/ecommerce/product/detail/' + item.comment.put_id + '/comments/' + item.cmt_id
        } else {
          return '/blog/detail/' + item.comment.blg_id + '/comments/' + item.cmt_id
        }
      }
    },
    handleRefresh() {
      this.loading = true
      this.$store.dispatch('notification/getList')
        .finally(() => {
          this.loading = false
          this.loaded = true
        })
    },
    setRead(ids, item = null) {
      return new Promise((resolve, reject) => {
        if (item !== null && item.is_seen_count === 0) {
          resolve()
          return false
        }
        this.$store.dispatch('notification/delete', ids)
          .then(() => {
            resolve()
          })
          .catch(error => {
            let errorBag
            if (error.response === undefined) {
              errorBag = {
                message: 'ERROR 520: Něco se pokazilo',
                description: error,
              }
            } else if (error.response.data === undefined) {
              errorBag = {
                message: 'ERROR ' + error.response.status + ': Něco se pokazilo',
                description: error.response,
              }
            } else {
              let description = ''
              for (const errorKey in error.response.data.errors) {
                description += error.response.data.errors[errorKey]
              }
              errorBag = {
                message: 'ERROR ' + error.response.status + ': ' + error.response.data.message,
                description: description,
              }
            }
            this.$notification.error(errorBag)
            reject(errorBag)
          })
      })
    },
    setUnRead(id) {
      this.$store.dispatch('notification/patch', id)
        .catch(error => {
          let errorBag
          if (error.response === undefined) {
            errorBag = {
              message: 'ERROR 520: Něco se pokazilo',
              description: error,
            }
          } else if (error.response.data === undefined) {
            errorBag = {
              message: 'ERROR ' + error.response.status + ': Něco se pokazilo',
              description: error.response,
            }
          } else {
            let description = ''
            for (const errorKey in error.response.data.errors) {
              description += error.response.data.errors[errorKey]
            }
            errorBag = {
              message: 'ERROR ' + error.response.status + ': ' + error.response.data.message,
              description: description,
            }
          }
          this.$notification.error(errorBag)
        })
    },
  },
  created() {
    this.$store.dispatch('notification/getCount')
  },
  watch: {
    visible(newValue, oldValue) {
      if (newValue && !this.loaded) {
        this.handleRefresh()
      }
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
